// redux/wholesaler/ThunkAction.ts

import { createAsyncThunk } from "@reduxjs/toolkit";
import { iStateMessage } from "@/customTypes/GenericReduxTypes";
import { iGenericResponse } from "@/customTypes/CommonServiceTypes";
import { curryGetThunkName } from "@/projectUtils/ReduxUtil";
import { httpStatusCodes } from "@/customTypes/NetworkTypes";
import { amountService } from "@/services/api/cresivoxServer";
import { REDUCER_NAME } from "./Types";

const curriedGetThunkName = curryGetThunkName(REDUCER_NAME);

// PATCH - Lock Balance Amount
export const addLockAmount = createAsyncThunk<
  iGenericResponse<any | null> | null,
  { userId: string; lockBalance: number | string }, 
  {
    rejectValue: iStateMessage;
  }
>(
  curriedGetThunkName("addLockAmount"),
  // @ts-expect-error
  async ({ userId, lockBalance }, { rejectWithValue }) => { 
    try {
      const response = await amountService.addLockAmount(userId, lockBalance); // <== passing correct p

      if (response) {
        const { httpStatusCode, data, message } = response;

        // SUCCESS
        if (httpStatusCode === httpStatusCodes.SUCCESS_OK && data?.data) {
          return {
            httpStatusCode,
            data: data.data,
            message,
          };
        }

        // FAILED OR ERROR
        return rejectWithValue({
          httpStatusCode,
          message,
        });
      }

      // NO RESPONSE
      return rejectWithValue({
        message: "No response received",
      });
    } catch (error) {
      return rejectWithValue({
        message: "Something went wrong",
      });
    }
  }
);


 export const getLockAmount = createAsyncThunk<
  iGenericResponse<any | null> | null,
  void,
  { rejectValue: iStateMessage }
>(
    // @ts-expect-error
  curriedGetThunkName("getLockAmount"),async (_, { rejectWithValue }) => {
    try {
      const response = await amountService.getLockAmount();

      if (!response) return rejectWithValue({ message: "No response received" });

      const { httpStatusCode, data, message } = response;

      if (httpStatusCode === httpStatusCodes.SUCCESS_OK && data?.data) {
        return { data: data.data, message };     // 🔥 now return correct format
      }

      return rejectWithValue({ httpStatusCode, message });
    } catch (err) {
      return rejectWithValue({ message: "Something went wrong" });
    }
  }
);
